import React from 'react';
import "./css/payment.css";

function PDFAddress({ dataTabelB }) {

  const nameCus1 = dataTabelB?.SNAM + "" + dataTabelB?.NAME1 + " " + dataTabelB?.NAME2;

  let T1, A1, J1;
  J1 = `จ. ${dataTabelB?.PROVDES}`;
  if (dataTabelB?.PROVCOD === "01") {
    T1 = `แขวง ${dataTabelB?.TUMB}`;
    A1 = `เขต ${dataTabelB?.AUMPDES}`;
  } else {
    T1 = `ต.${dataTabelB?.TUMB}`;
    A1 = `อ.${dataTabelB?.AUMPDES}`;
  }

  let newNameType = "คนค้ำ"
  if (dataTabelB.contractSchema === "lsfhp" && dataTabelB.customerTypeId === 0) { // 1
    newNameType = "ผู้กู้"
  } else if ((dataTabelB.contractSchema === "vsfhp" || dataTabelB.contractSchema === "sfhp") && dataTabelB.customerTypeId === 0) {  // 2 8
    newNameType = "ผู้เช่าซื้อ"
  } else if ((dataTabelB.contractSchema === "psfhp" || dataTabelB.contractSchema === "rpsl") && dataTabelB.customerTypeId === 0) {  // 3 เก่า/ใหม่
    newNameType = "ผู้กู้"
  } else {
    newNameType = `คนค้ำ ${dataTabelB.GARNO}`
  }

  return (
    <div style={{ fontSize: '16px', color: '#000' }}>
      {nameCus1} ({newNameType}) ({dataTabelB?.CONTNO}) <br />
      เลขที่ {dataTabelB?.ADDR1} {dataTabelB?.ADDR2} <br />
      {T1} {A1} {J1} <br />
      {dataTabelB?.ZIP} <br />
      <div style={{ borderBottom: '1px solid #000', width: '100%' }}></div>
    </div>
  );
}

export default PDFAddress;